var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, css, html } from "lit";
import { property, state } from "lit/decorators.js";
import { documentCss } from "./styles.js";
export class QboFileViewer extends LitElement {
    constructor() {
        super(...arguments);
        this.url = '/documents/files/';
        this.provider = null;
        this.path = null;
        this.mimetype = null;
        this.mappings = [];
    }
    static { this.styles = [
        documentCss,
        css ``
    ]; }
    async connectedCallback() {
        super.connectedCallback();
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    closeViewer() {
        const event = new CustomEvent('close', {
            detail: { provider: this.provider, path: this.path },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    render() {
        const isImage = this.mimetype?.startsWith('image/');
        return html `
<article class="qbo-file-viewer">
    <header>
        <a href="/documents/files/download/${this.provider}/${this.path}" title="Download this file to your computer.">${this.path}</a>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="${this.closeViewer}"></button>
    </header>
    ${isImage ? this.renderImage() : this.renderObject(this.mimetype ?? "text/html")}
</article>`;
    }
    renderObject(toMimeType) {
        return html `<object data="/documents/files/view/${this.provider}/${this.path}" type="${toMimeType}" width="100%" height="600px">
    <p>It appears you don't have a plugin for this file type. You can <a href="/documents/files/download/${this.provider}/${this.path}">click here to download the file.</a></p>
</object>`;
    }
    renderImage() {
        return html `<img src="/documents/files/view/${this.provider}/${this.path}" alt="${this.path}" style="width: 100%; height: auto; display: block;" />`;
    }
}
__decorate([
    property(),
    __metadata("design:type", String)
], QboFileViewer.prototype, "url", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboFileViewer.prototype, "provider", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboFileViewer.prototype, "path", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboFileViewer.prototype, "mimetype", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], QboFileViewer.prototype, "mappings", void 0);
if (!customElements.get('qbo-file-viewer'))
    customElements.define('qbo-file-viewer', QboFileViewer);
